<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Fees Component</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search"
                @current-items="getFiltered" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar flat dense color="white">
                        <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button" v-on="on">Add Fees Component</v-btn>
                            </template>
                            <v-card>
                                <v-card-title class="toolbar">
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-text-field dense rounded outlined
                                                    v-model="addedItem.fees_component_super_master_list"
                                                    label="Enter Fees Component"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field v-model="editedItem.feesComponent" dense rounded outlined
                                                    persistent-hint hint="For example :: Tution Fees, Development Fees"
                                                    label="Fees Component"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-text-field dense rounded outlined v-model="addedItem.sortorder"
                                                    label="Enter SortOrder" type="number"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-text-field v-model="editedItem.sortorder" dense rounded outlined
                                                    persistent-hint hint="For example :: 1,2,3"
                                                    label="Sort Order"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined
                                                    :items="fees_component_category_list"
                                                    item-text="feesComponentcategory" item-value="id"
                                                    v-model="addedItem.feesComponentcategory"
                                                    label="Select Fees Component Category"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined
                                                    :items="fees_component_category_list"
                                                    item-text="feesComponentcategory"
                                                    v-model="editedItem.feesComponentcategory"
                                                    label="Select Fees Component Category"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined :items="stdList" item-text="standard"
                                                    item-value="id" v-model="addedItem.standard"
                                                    label="Select Standard" multiple></v-autocomplete>
                                            </v-col>
                                            
                                             <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined :items="stdList" item-text="standard"
                                                    v-model="editedItem.standard_id" item-value="id"
                                                    label="Select Standard"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                <v-autocomplete dense rounded outlined :items="aylist" item-text="ay"
                                                    item-value="id" v-model="addedItem.ay"
                                                    label="Select Academic Year"></v-autocomplete>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                <v-autocomplete dense rounded outlined :items="aylist" item-text="ay"
                                                    v-model="editedItem.ay"
                                                    label="Select Academic Year"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                    label="Active"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.is_receivable" color="success"
                                                    label="Is Receivable"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex == -1">
                                                <v-checkbox dense v-model="addedItem.is_receivable" color="success"
                                                    label="Is Receivable"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.is_register_component" color="success"
                                                    label="Is Register Component"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex == -1">
                                                <v-checkbox dense v-model="addedItem.is_register_component" color="success"
                                                    label="Is Register Component"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                <v-checkbox dense v-model="editedItem.is_discount_excluded" color="success"
                                                    label="Is Discount Excluded"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4" v-if="editedIndex == -1">
                                                <v-checkbox dense v-model="addedItem.is_discount_excluded" color="success"
                                                    label="Is Discount Excluded"></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn class="button" @click="close">Cancel</v-btn>
                                    <v-btn class="button" @click="save">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>

                    <!-- ss -->
                    <template>
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                    <!-- ss -->
                </template>

                <template v-slot:item.isactive="{ item }">
                    <!-- <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span> -->
                    <v-switch color="brand" @change="edit_iscative_receivable_component(item.id,item.isactive,item.is_receivable,item.is_register_component)"
                        dense hide-details v-model="item.isactive"></v-switch>
                </template>
                <template v-slot:item.is_receivable="{ item }">
                    <!-- <span v-if="item.is_receivable">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span> -->
                    <v-switch color="brand" @change="edit_iscative_receivable_component(item.id,item.isactive,item.is_receivable,item.is_register_component,item.is_discount_excluded)"
                        dense hide-details v-model="item.is_receivable"></v-switch>
                </template>
                <template v-slot:item.is_register_component="{ item }">
                    <v-switch color="brand" @change="edit_iscative_receivable_component(item.id,item.isactive,item.is_receivable,item.is_register_component,item.is_discount_excluded)"
                        dense hide-details v-model="item.is_register_component"></v-switch>
                </template>

                <template v-slot:item.is_discount_excluded="{ item }">
                    <v-switch color="brand" @change="edit_iscative_receivable_component(item.id,item.isactive,item.is_receivable,item.is_register_component,item.is_discount_excluded)"
                        dense hide-details v-model="item.is_discount_excluded"></v-switch>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                    <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
                </template>
                <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
            
            overlay: false,
            filterArr: [],
        // extraBreadcrumbItems: [
        //     { text: "Fees Component", disabled: true, href: "" },

        // ],
        // breadcrumbClass: "breadcrumb-style1",
            filters: {
                ay: [],
                feesComponentcategory: [],
                standard:[]
            },
            errorMsg: {
                feesComponent: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            fees_component_super_master_list: null,
            academicYear: null,
            aylist: null,
            stdList:[],
            current_ay: "",
            //sortorder:0,
            fees_component_category_list: null,
            headers: [
                {
                    text: "Fees Component",
                    align: "left",
                    sortable: false,
                    value: "feesComponent",
                },
                {
                    text: "Sort Order",
                    align: "left",
                    sortable: false,
                    value: "sortorder",
                },
                {
                    text: "Fees Component Category",
                    align: "left",
                    sortable: false,
                    value: "feesComponentcategory",
                },
                 {
                    text: "Standard",
                    align: "left",
                    sortable: false,
                    value: "standard",
                },
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "ay",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                {
                    text: "Is Receivable",
                    align: "left",
                    sortable: true,
                    value: "is_receivable",
                },
                {
                    text: "Is Register Compnent",
                    align: "left",
                    sortable: true,
                    value: "is_register_component",
                },
                {
                    text: "Is Discount Excluded",
                    align: "left",
                    sortable: true,
                    value: "is_discount_excluded",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            fees_component_list: [],
            editedIndex: -1,
            addedItem: {
                fees_component_super_master_list: "",
                feesComponentcategory: null,
                ay: null,
                is_receivable: false,
                is_register_component:false,
                is_discount_excluded:false,
                sortorder: 0,
            },
            editedItem: {
                id: "",
                feesComponent: "",
                feesComponentcategory: null,
                ay: null,
                standard_id:null,
                isactive: true,
                is_receivable: false,
                is_register_component:false,
                is_discount_excluded:false,
                sortorder: 0,
            },
            defaultItem: {
                id: "",
                feesComponent: "",
                isactive: true,
                sortorder: 0,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Fees Component" : "Edit Fees Component";
            },
            bookList1() {
                return this.fees_component_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },

            columnValueList(val) {
                return this.fees_component_list.map((d) => d[val]);
            },

            initializeErrorMsgFalse() {
                this.errorMsg.feesComponent = false;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AccountingAndFees/getFeesComponent")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            this.fees_component_super_master_list = res.data.fees_component_super_master_list;
                            this.academicYear = res.data.academicYear;
                            this.aylist = res.data.aylist;
                            this.stdList = res.data.stdList;
                            this.fees_component_list = res.data.fees_component_list;
                            this.fees_component_category_list = res.data.fees_component_category_list;
                            this.addedItem.ay = res.data.academicYear;
                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            editItem(item) {
                this.editedIndex = this.fees_component_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            // deleteItem (item) {
            //   const index = this.fees_component_super_master_list.indexOf(item)
            //   confirm('Are you sure you want to delete this item?') && this.fees_component_super_master_list.splice(index, 1)
            // },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            edit_iscative_receivable_component(id,isactive,is_receivable,is_register_component,is_discount_excluded) {
                const data={
                    id:id,
                    isactive:isactive,
                    is_receivable:is_receivable,
                    is_register_component:is_register_component,
                    is_discount_excluded:is_discount_excluded
                }
                axios
                    .post("/AccountingAndFees/edit_iscative_receivable_component", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.onLoad();
                            this.showSnackbar("#4caf50", "Fees Component updated successfully..."); // show snackbar on success
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.editedItem.feesComponent = "";
                    });

                this.close();
            },
            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.feesComponentcategory == "" || this.editedItem.feesComponentcategory == null) {
                        this.showSnackbar("#b71c1c", "Please select Fees Component Category!!!");
                        return false;
                    }
                    if (this.editedItem.ay == "" || this.editedItem.ay == null) {
                        this.showSnackbar("#b71c1c", "Please select Academic Year!!!");
                        return false;
                    } else {
                        if (this.isValidated()) {
                            axios
                                .post("/AccountingAndFees/editFeesComponent", this.editedItem)
                                .then((res) => {
                                    if (res.data.status.code == "SUCCESS") {
                                        // Object.assign(
                                        //   this.fees_component_list[this.editedIndex],
                                        //   this.editedItem
                                        // );
                                        this.onLoad();
                                        this.showSnackbar("#4caf50", "Fees Component updated successfully..."); // show snackbar on success
                                    } else if (res.data.status.code == "NA") {
                                        this.showSnackbar("#b71c1c", "Fees Component / sort order already present!!!");
                                        // show snackbar on error
                                    }
                                })
                                .catch((error) => {
                                    window.console.log(error);
                                })
                                .finally(() => {
                                    this.editedItem.feesComponent = "";
                                });

                            this.close();
                        }
                    }
                } else {
                    if (this.addedItem.fees_component_super_master_list == "" || this.addedItem.fees_component_super_master_list == null) {
                        this.showSnackbar("#b71c1c", "Please enter Fees Component!!!");
                        return false;
                    }
                    if (this.hasWhiteSpace(this.addedItem.fees_component_super_master_list)) {
                        this.showSnackbar("#b71c1c", "Please enter Fees Component!!!");
                        return false;
                    }
                    if (this.addedItem.feesComponentcategory == "" || this.addedItem.feesComponentcategory == null) {
                        this.showSnackbar("#b71c1c", "Please select Fees Component Category!!!");
                        return false;
                    }
                    if (this.addedItem.ay == "" || this.addedItem.ay == null) {
                        this.showSnackbar("#b71c1c", "Please select Academic Year!!!");
                        return false;
                    } else {
                        axios
                            .post("/AccountingAndFees/saveFeesComponent", this.addedItem)
                            .then((res) => {
                                if (res.data.status.code == "SUCCESS") {
                                    //   this.fees_component_list.push(this.addedItem);
                                    this.showSnackbar("#4caf50", "Fees Component added successfully..."); // show snackbar on success
                                    this.onLoad();
                                    // this.addedItem.fees_component_super_master_list = "";
                                    // this.addedItem.ay = "";
                                    // this.addedItem.feesComponentcategory = "";
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Fees Component / sort order already present!!!");
                                    // show snackbar on error
                                }
                            })

                            .catch((error) => {
                                window.console.log(error);
                            })
                            .finally(() => {
                                this.addedItem.fees_component_super_master_list = "";
                            });

                        this.close();
                    }
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.feesComponent) {
                    return true;
                } else {
                    if (!this.editedItem.feesComponent) {
                        this.errorMsg.feesComponent = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
    .mytable /deep/ thead th {
        background: #2980b9;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
